{
  "name": "ton",
  "version": "13.6.1",
  "repository": "https://github.com/ton-core/ton.git",
  "author": "Whales Corp. <developers@whalescorp.com>",
  "license": "MIT",
  "main": "dist/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "docs": "rm -fr docs && typedoc src/index.ts",
    "build": "rm -fr dist && tsc --declaration",
    "test": "jest --verbose --runInBand",
    "release": "yarn build && yarn release-it --npm.yarn1"
  },
  "devDependencies": {
    "@release-it/keep-a-changelog": "^3.1.0",
    "@types/jest": "^27.0.1",
    "@types/node": "^16.7.10",
    "buffer": "^6.0.3",
    "expect": "^27.1.0",
    "jest": "^27.1.0",
    "jest-mock": "^27.1.0",
    "karma": "^6.3.4",
    "karma-chrome-launcher": "^3.1.0",
    "karma-jasmine": "^4.0.1",
    "karma-typescript": "^5.5.2",
    "karma-webpack": "^5.0.0",
    "prando": "^6.0.1",
    "release-it": "^15.5.1",
    "ton-core": "^0.52.0",
    "ton-crypto": "3.2.0",
    "ton-emulator": "^2.1.1",
    "ts-jest": "^27.0.5",
    "ts-loader": "^9.2.5",
    "ts-node": "^10.7.0",
    "typedoc": "^0.23.24",
    "typescript": "^4.4.2",
    "webpack": "^5.51.2"
  },
  "dependencies": {
    "axios": "^0.25.0",
    "dataloader": "^2.0.0",
    "symbol.inspect": "1.0.1",
    "teslabot": "^1.3.0",
    "zod": "^3.21.4"
  },
  "peerDependencies": {
    "ton-core": ">=0.51.0",
    "ton-crypto": ">=3.2.0"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "release-it": {
    "github": {
      "release": true
    },
    "plugins": {
      "@release-it/keep-a-changelog": {
        "filename": "CHANGELOG.md"
      }
    }
  },
  "packageManager": "yarn@3.4.1"
}
